module.exports = __webpack_public_path__ + "img/78.e29fbb65.jpg";